import { SubscriptionItem, SubscriptionItemDraft, SubscriptionItemType } from "../types";

export function subscriptionItemToDraft(item: SubscriptionItem): SubscriptionItemDraft {
  const { id, date, ...draft } = item;
  return draft;
}
